export default __webpack_public_path__ + "static/media/mapCapa.d4dc517a.jpg";